
// ----------------------------------------------------------------------
// <copyright file="Izenda.LazyLoadingTreeViewItemList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {
  var React = require('react');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var observer = require('mobx-react').observer;
  var LazyLoading = require('../LazyLoading/Izenda.LazyLoading');
  var LazyLoadingTreeViewItem = require('./Izenda.LazyLoadingTreeViewItem');
  var classnames = require('classnames');

  var LazyLoadingTreeViewItemList = React.createClass({
    propTypes: {
      treeStore: ObservablePropTypes.observableObject,
      isLastPage: React.PropTypes.bool.isRequired,
      registerLazyLoadingStore: React.PropTypes.func
    },
    componentWillMount: function () {
      var props = this.props;
      var treeStore = props.treeStore;
      treeStore.setNodes(props.flattenNodes);
    },
    componentWillReceiveProps: function (nextProps) {
      var treeStore = nextProps.treeStore;
      treeStore.setNodes(nextProps.flattenNodes);
    },

    render: function () {
      var props = this.props;
      var treeStore = props.treeStore;
      var visibleNodes = treeStore.visibleNodeList;
      var hasItems = visibleNodes.length;
      var className = classnames('izenda-TreeViewItemList', props.className);

      return (
        <LazyLoading
          className={className}
          data={visibleNodes}
          isLastPage={props.isLastPage}
          getData={props.getData}
          renderItem={this.renderItem}
          viewHeight={props.viewHeight}
          itemHeight={props.itemHeight}
          defaultItemsNumber={props.defaultItemsNumber}
          registerLazyLoadingStore={props.registerLazyLoadingStore}/>
      );
    },

    renderItem: function (node, pageSize, loadVirtualNode) {
      var props = this.props;
      var renderNode = props.renderNode;
      var treeStore = props.treeStore;
      var expanded = treeStore.isExpanded(node);

      return (
        <LazyLoadingTreeViewItem
          node={node}
          treeViewItemClassName={props.treeViewItemClassName}
          renderNode={renderNode}
          expanded={expanded}
          toggleCollapsible={treeStore.toggleCollapsibleOfNode.bind(treeStore)}
          getData={props.getData}
          pageSize={pageSize} 
          loadVirtualNode={loadVirtualNode}/>);
    },
    getKey: function (node) {
      return node.key;
    }
  });

  module.exports = observer(LazyLoadingTreeViewItemList);
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/LazyLoadingTreeView/Izenda.LazyLoadingTreeViewItemList.jsx